/* import __COLOCATED_TEMPLATE__ from './shopify-created-order-duplicate.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();